<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" v-if="estaActivo" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <!-- Menu -->
      <v-list dense>
        <!-- Dashboard -->
        <template v-if="esSuperadministrador || esAdministrador || esSupervisor || esVerificador || esAlmacenero">
          <v-list-item :to="{ name: 'Dashboard' }">
            <v-list-item-icon>
              <v-icon>dashboard</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item>
        </template>
        <!-- Fin Dashboard -->

        <!-- Bien -->
        <v-list-group no-action v-if="esSuperadministrador || esAdministrador || esSupervisor || esVerificador">
          <template slot="activator">
            <v-list-item-action>
              <v-icon>inventory</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Inventario</v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-if="esSuperadministrador || esAdministrador || esSupervisor">
            <v-list-item :to="{ name: 'Local' }">
              <v-list-item-title>Locales</v-list-item-title>
              <v-list-item-icon>
                <v-icon>location_city</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
          <template v-if="esSuperadministrador || esAdministrador || esSupervisor">
            <v-list-item :to="{ name: 'Area' }">
              <v-list-item-title>Areas</v-list-item-title>
              <v-list-item-icon>
                <v-icon>hub</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
          <template v-if="esSuperadministrador || esAdministrador || esSupervisor || esVerificador">
            <v-list-item :to="{ name: 'Personal' }">
              <v-list-item-title>Personal</v-list-item-title>
              <v-list-item-icon>
                <v-icon>face</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
          <template v-if="esSuperadministrador || esAdministrador || esSupervisor || esVerificador">
            <v-list-item :to="{ name: 'Bien' }">
              <v-list-item-title>Bienes Activos</v-list-item-title>
              <v-list-item-icon>
                <v-icon color="indigo">category</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
          <template v-if="esSuperadministrador || esAdministrador || esSupervisor">
            <v-list-item :to="{ name: 'BajaBien' }">
              <v-list-item-title>Baja de Bienes</v-list-item-title>
              <v-list-item-icon>
                <v-icon>padding</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
          <template v-if="esSuperadministrador || esAdministrador || esSupervisor || esVerificador">
            <v-list-item :to="{ name: 'TrasladoBien' }">
              <v-list-item-title>Traslado de Bienes</v-list-item-title>
              <v-list-item-icon>
                <v-icon>move_down</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>

          <v-list-group sub-group no-action v-if="esSuperadministrador || esAdministrador">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Más Opciones</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item :to="{ name: 'TipoBien' }">
              <v-list-item-title>Tipo de Bienes</v-list-item-title>
              <v-list-item-icon>
                <v-icon>list</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item :to="{ name: 'Cuentac' }">
              <v-list-item-title>Cuenta Contable</v-list-item-title>
              <v-list-item-icon>
                <v-icon>list</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-group>
        </v-list-group>
        <!-- Fin Bien -->

        <!-- Almacen -->
        <!-- <v-list-group no-action v-if="esSuperadministrador || esAdministrador || esSupervisor || esAlmacenero">
          <template slot="activator">
            <v-list-item-action>
              <v-icon>home_work</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Almacen</v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-if="esSuperadministrador || esAdministrador || esSupervisor || esAlmacenero">
            <v-list-item :to="{ name: 'Orden' }">
              <v-list-item-title>Listado de Orden</v-list-item-title>
              <v-list-item-icon>
                <v-icon>apps</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
        </v-list-group> -->
        <!-- Fin Almacen -->

        <!-- Menu Reportes -->
        <v-list-group no-action v-if="esSuperadministrador || esAdministrador || esSupervisor || esVerificador">
          <template slot="activator">
            <v-list-item-action>
              <v-icon>fact_check</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Reportes</v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-if="esSuperadministrador || esAdministrador || esSupervisor || esVerificador">
            <v-list-item :to="{ name: 'ReporteAsignacion' }">
              <v-list-item-content>
                <v-list-item-title>Asignación de Bienes</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>article</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
          <template v-if="esSuperadministrador || esAdministrador || esSupervisor || esVerificador">
            <v-list-item :to="{ name: 'ReporteDepreciacion' }">
              <v-list-item-content>
                <v-list-item-title>Depreciación Bienes</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>article</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
          <template v-if="esSuperadministrador || esAdministrador || esSupervisor || esVerificador">
            <v-list-item :to="{ name: 'ReporteUsuario' }">
              <v-list-item-content>
                <v-list-item-title>Bienes x Usuario</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>article</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
          <template v-if="esSuperadministrador || esAdministrador || esSupervisor">
            <v-list-item :to="{ name: 'ReporteBien' }">
              <v-list-item-content>
                <v-list-item-title>Bienes Activos</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>article</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
          <template v-if="esSuperadministrador || esAdministrador || esSupervisor">
            <v-list-item :to="{ name: 'ReporteBajaBien' }">
              <v-list-item-content>
                <v-list-item-title>Baja de Bienes</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>article</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
        </v-list-group>
        <!-- Fin Menu Reportes -->

        <!-- Configuracion -->
        <v-list-group no-action v-if="esSuperadministrador || esAdministrador">
          <template slot="activator">
            <v-list-item-action>
              <v-icon>settings</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Configuración</v-list-item-title>
            </v-list-item-content>
          </template>
          <!-- Empresa -->
          <template>
            <v-list-item :to="{ name: 'Empresa' }">
              <v-list-item-title>Empresa</v-list-item-title>
              <v-list-item-icon>
                <v-icon>business</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
          <!-- Fin Empresa -->

          <!-- Usuario -->
          <template>
            <v-list-item :to="{ name: 'Usuario' }">
              <v-list-item-title>Usuarios</v-list-item-title>
              <v-list-item-icon>
                <v-icon>manage_accounts</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
          <!-- Fin Usuario -->
        </v-list-group>
        <!-- Fin configuracion -->
      </v-list>
    </v-navigation-drawer>

    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp"
      :color="empresaState.color_app ? $vuetify.theme.themes.light.primary = empresaState.color_app : $vuetify.theme.themes.light.primary"
      dense app color="primary" dark>
      <!-- Logo y titulo -->
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="estaActivo"></v-app-bar-nav-icon>
      <v-toolbar-title style="width: 200px" class="ml-0">
        <v-avatar tile size="35px" class="mx-1" large item>
          <v-img :src="require('./assets/logo.png')" alt="Vuetify" />
        </v-avatar>
        <span>S I M E</span>
      </v-toolbar-title>
      <!-- Fin Logo y titulo -->
      <v-spacer />

      <!-- Accesos directos Bien, Local, area y Configuracion -->
      <template>
        <v-tooltip bottom v-if="esSuperadministrador || esAdministrador || esSupervisor">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="irLocal">
              <v-icon>location_city</v-icon>
            </v-btn>
          </template>
          <span>Locales</span>
        </v-tooltip>
        <v-tooltip bottom v-if="esSuperadministrador || esAdministrador || esSupervisor">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="irArea">
              <v-icon>hub</v-icon>
            </v-btn>
          </template>
          <span>Areas</span>
        </v-tooltip>
        <v-tooltip bottom v-if="esSuperadministrador || esAdministrador || esSupervisor || esVerificador">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="irPersonal">
              <v-icon>face</v-icon>
            </v-btn>
          </template>
          <span>Personal</span>
        </v-tooltip>
        <v-tooltip bottom v-if="esSuperadministrador || esAdministrador || esSupervisor || esVerificador">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="irBien">
              <v-icon>category</v-icon>
            </v-btn>
          </template>
          <span>Bienes</span>
        </v-tooltip>
      </template>
      <!-- Fin Accesos directos Bien, Local, area y Configuracion -->
      <v-spacer />
      <!-- Link Pagina -->
      <v-toolbar-items class="hidden-sm-and-down" v-if="!estaActivo">
        <v-btn v-for="item, i in menu" :key="i" :to="item.link" text>{{ item.name }}</v-btn>
      </v-toolbar-items>

      <v-menu>
        <template v-slot:activator="{ on }">
          <v-btn class="hidden-md-and-up" v-if="!estaActivo" v-on="on" text fab>
            <v-icon>menu</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item v-for="item, i in menu" :key="i" :to="item.link">
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- Fin Link Pagina -->

      <!-- Modo oscuro -->
      <v-btn icon dark hide-details @click="$vuetify.theme.dark = !$vuetify.theme.dark" v-if="estaActivo">
        <v-icon>dark_mode</v-icon>
      </v-btn>
      <!-- Fin Modo oscuro -->

      <!-- Menu para cerrar sesion -->
      <v-menu bottom left v-model="menuSesion" :close-on-content-click="false" :nudge-width="200" offset-y
        v-if="estaActivo">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-avatar size="35px">
              <template v-if="usuarioState.avatar == 1">
                <img :src="img1" />
              </template>
              <template v-else-if="usuarioState.avatar == 2">
                <img :src="img2" />
              </template>
              <template v-else-if="usuarioState.avatar == 3">
                <img :src="img3" />
              </template>
              <template v-else="usuarioState.avatar==4">
                <img :src="img4" />
              </template>
            </v-avatar>
          </v-btn>
        </template>

        <v-card>
          <v-list dense>
            <v-list-item>
              <v-list-item-avatar>
                <v-avatar size="40px" item>
                  <template v-if="usuarioState.avatar == 1">
                    <img :src="img1" />
                  </template>
                  <template v-else-if="usuarioState.avatar == 2">
                    <img :src="img2" />
                  </template>
                  <template v-else-if="usuarioState.avatar == 3">
                    <img :src="img3" />
                  </template>
                  <template v-else="usuarioState.avatar==4">
                    <img :src="img4" />
                  </template>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ usuarioState.nickname }}</v-list-item-title>
                <v-list-item-subtitle>{{ usuarioState.rol }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider />
          <v-list dense>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>badge</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ usuarioState.nomape.substring(0, 20) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>business</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ usuarioState.empresa.substring(0, 20) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>corporate_fare</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ usuarioState.tipoempresa }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>verified</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ usuarioState.seguimientoinv == 'SI' ? 'SEG. INVENTARIO: ' + usuarioState.anoinv
                  :
                  'SEG. INVENTARIO: ' + usuarioState.seguimientoinv }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-card-actions>
            <v-btn small text block color="error" @click="salir(), (menuSesion = false)">Cerrar sesión</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
      <!-- Fin Menu para cerrar sesion -->
    </v-app-bar>
    <!-- Contenido -->
    <v-main>
      <v-slide-y-transition mode="out-in">
        <router-view />
      </v-slide-y-transition>
    </v-main>
    <!-- Fin Contenido -->

    <!-- Pie de Pagina -->
    <v-footer app color="primary" padless>
      <v-row no-gutters class="primary text-center" v-if="!estaActivo">
        <v-col cols="12">
          <div class="font-weight-regular text-h7 white--text mt-4">
            <a class="white--text" target="_blank" href="https://wa.me/+51930984158" style="text-decoration:none">+51
              930984158</a>
            <a class="white--text" target="_blank" href="https://www.facebook.com/urpisoft"
              style="text-decoration:none"><v-icon dark class="mb-1 mx-1">facebook</v-icon></a>
          </div>
          <div class="font-weight-regular text-h7 white--text">
            <v-icon dark class="mb-1 mx-1">location_on</v-icon>Jr. Los Pinos Mz. D Lt. 4, Urb. La Florida , Juliaca.
          </div>
          <div class="font-weight-regular text-h7 white--text mb-4">
            <v-icon dark class="mb-1 mx-1">email</v-icon>efrain@urpisoft.pe
          </div>
        </v-col>
      </v-row>
      <v-card-text class="primary darken-2 text-center white--text pa-1">Copyright © SIME {{ new Date().getFullYear() }}
        Todos los derechos reservados. v{{ version }}</v-card-text>
    </v-footer>
    <!-- Fin Pie de Pagina -->
  </v-app>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex"; // Importamos para llamar a los elementos salir, autologin, usuario, etc

export default {
  name: "App",
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
      drawer: null,
      menuSesion: false,
      menu: [
        { link: "home", name: "INICIO" },
        //{ link: "nosotros", name: "NOSOTROS" },
        { link: "servicios", name: "SERVICIOS" },
        { link: "contacto", name: "CONTACTO" },
        { link: "login", name: "LOG IN" },
      ],
      // Avatar
      img1: "data:image/png;base64,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",
      img2: "data:image/png;base64,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",
      img3: "data:image/png;base64,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",
      img4: "data:image/png;base64,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",
    };
  },

  computed: {
    ...mapGetters([
      "estaActivo",
      "esSuperadministrador",
      "esAdministrador",
      "esSupervisor",
      "esVerificador",
      "esAlmacenero",
    ]),

    ...mapState(["usuarioState", "empresaState"]), // Llamamos a state para usuario
  },

  created() {
    this.autoLogin();
  },

  methods: {
    ...mapActions(["salir", "autoLogin"]), // Llamamos a actions salir, autologin

    irBien() {
      this.$router.push({ name: "Bien" }).catch(() => { });
    },
    irLocal() {
      this.$router.push({ name: "Local" }).catch(() => { });
    },
    irArea() {
      this.$router.push({ name: "Area" }).catch(() => { });
    },
    irPersonal() {
      this.$router.push({ name: "Personal" }).catch(() => { });
    },
  },
};
</script>
